import { render } from "./Tarieven.vue?vue&type=template&id=7cae1244&scoped=true&ts=true"
import script from "./Tarieven.vue?vue&type=script&lang=ts"
export * from "./Tarieven.vue?vue&type=script&lang=ts"

import "./Tarieven.vue?vue&type=style&index=0&id=7cae1244&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cae1244"]])

export default __exports__